import React from 'react';
import { FaGithub } from "react-icons/fa";
import { CgFileDocument } from "react-icons/cg";

const ProjectBox = ({ projectName }) => {
  // Project descriptions and links
  const projects = {
    "ZCoder": {
      description: "Developed a dynamic, interactive coding platform. Implemented secure authentication, extensive problem browsing and solution submission/viewing. Designed following microservices architecture and design patterns, ensuring reusability. Enhanced API testing with Postman and secure data handling with REST APIs.",
      github: "https://github.com/rishinotfound/Zcoder.git",
      demo: "",
    },
    "ANOMALISE": {
      description: "Built an ML-powered anomaly detection pipeline using SVM model, achieving 91.2% accuracy for real-world network monitoring scenarios and offline detection workflows that analyze anomalies from any given test dataset. Improved performance by optimizing preprocessing, model evaluation, and backend API workflows.",
      github: "https://github.com/PraaNori/Network-Intrusion-Detection",
      demo: "https://youtu.be/x5N3c1EA3HA",
    },
    "ShroudX": {
      description: "Developed secure data transmission using 4 custom AES text-in-text steganography algorithms. Designed a microservice-based backend ensuring low-latency encryption and decryption operations. Implemented RESTful APIs for seamless integration with front-end applications. Enhanced security with robust error handling and input validation.",
      github: "https://github.com/PraaNori/ShroudX",
      demo: "https://youtu.be/Oz_9VraoEec",
    },
     "MIPS Simulator": {
      description: "Developed a Python-based MIPS simulator for system development, handling R-type, I-type, and J-type instructions without pipelining. Simulated memory, registers, and program flow to execute instructions sequentially, enhancing understanding of computer architecture and assembly translation.",
      github: "https://github.com/PraaNori/MIPS-Simulator",
      demo: "",
    },
    "CDN Optimisation": {
      description: "Built a Content Delivery Network (CDN) server application that efficiently distributes and displays movie images. Developed in C++ and Qt for a responsive GUI, this application enables users to view popular movie images or search for specific titles based on location. ",
      github: "https://github.com/PraaNori/CDN_Optimization",
      demo: "",
    },
    "Tiny Trolly": {
      description: "Developed a GUI-based mini e-commerce platform using GTK, showcasing GUI rendering, widget management, and event handling. Implemented category browsing for fashion, furniture, electronics, and books with responsive UI interactions. Ensured modular architecture for easy feature expansion and smooth user workflows.",
      github: "https://github.com/PraaNori/Tiny-Trolley",
      demo: "",
    },
  };

  // Fetch the relevant project details
  const project = projects[projectName];

  // Handle missing projects gracefully
  if (!project) {
    return <div>Error: Project not found.</div>;
  }

  return (
    <div className='projectBox'>
      <div>
        <h3>{projectName}</h3>
        <p>{project.description}</p>
        <div>
          {project.github && (
            <a href={project.github} target='_blank' rel="noopener noreferrer">
              <button className='projectbtn'><FaGithub /> Github</button>
            </a>
          )}
          {project.demo && (
            <a href={project.demo} target='_blank' rel="noopener noreferrer">
              <button className='projectbtn'><CgFileDocument /> Demo</button>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProjectBox;
